module.exports = __webpack_public_path__ + "img/case-study-MOJ.c5246ac6.png";